import type { ChatPresentation } from '~/components/AiChat/controller/types';

export const CLAIM_CHAT_PRESENTATION: ChatPresentation = {
  assistantName: 'Clive',
  greeting:
    'Ask me anything about this claim — from coverage and payments to documents and communications. You can also use the + to add Context, upload files, or start from a template.',
  placeholder: 'Type here',
  disclaimer: 'Clive can make mistakes. Always check important info',
  failedText: 'Something went wrong generating a response. Please try again.',
};
